var map = {
	"./locale": 885,
	"./locale.js": 885
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2264;


//////////////////
// WEBPACK FOOTER
// ./~/moment-mini/locale ^\.\/.*$
// module id = 2264
// module chunks = 1